import { Provider } from '@angular/core'

import { MarkedOptions, Renderer } from 'marked'
import { MARKED_OPTIONS } from 'ngx-markdown'

import { environment } from '@teknor/env/environment'

export const provideMarkdownCustomRenderer = (): Provider => {
  return {
    provide: MARKED_OPTIONS,
    useFactory: () => {
      const renderer = new Renderer()

      renderer.image = ({ href, title, text }): string => {
        // Browser sends HttpOnly cookies automatically with image requests
        const finalSrc = href.startsWith('/v1/blobs/') ? `${environment.socketUrl}${href}` : href

        const escapedTitle = title ? ` title="${title}"` : ''
        const escapedAlt = text ? ` alt="${text}"` : ''

        const html = `<img src="${finalSrc}"${escapedAlt}${escapedTitle} />`
        return `<div class="markdown-image-container">${html}</div>`
      }

      const options: MarkedOptions = {
        renderer,
        gfm: true,
        breaks: true
      }

      return options
    }
  }
}
